import { createFileRoute } from '@tanstack/react-router';

import MerchantsPage from '@/components/store/merchants/Page';

export const Route = createFileRoute('/store/merchants/')({
	component: MerchantsPage,
});
